import { datadogRum, RumErrorEvent } from '@datadog/browser-rum'

export function initDatadog() {
  datadogRum.init({
    applicationId: '5990976a-eb54-4d9a-b150-96480241e843',
    clientToken: 'pub1580514874ea7edce55d994c39538ced',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'us5.datadoghq.com',
    service: 'rex',
    env: import.meta.env.VITE_UI_ENV, // testing only dev for now, will need to change to only prod later
    // Specify a version number to identify the deployed version of your application in Datadog
    version: APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend: (event) => {
      if (event.error) {
        const error = (event as RumErrorEvent).error
        // filter out error that might be caused by link validation/ pre-fetch rendering from email clicks
        // https://github.com/DataDog/browser-sdk/issues/2715
        const regex = /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/
        if (regex.test(error.message)) return false
      }

      return true
    },
  })
}
